import React from 'react';
import styled from 'styled-components';

import { getInitials } from '../utils/initials';

import Avatar, { AvatarItem } from '@atlaskit/avatar';
import { colors, fontFamily } from '@atlaskit/theme';

export type AccountDetailsProps = {
  readonly userName: string;
  readonly userEmail: string;
  readonly avatarSrc?: string;
};

export function AccountDetails({
  userName,
  userEmail,
  avatarSrc
}: AccountDetailsProps) {
  return (
    <AvatarItem
      avatar={
        avatarSrc !== undefined ? (
          <Avatar src={avatarSrc} />
        ) : (
          <Avatar
            component={({ className, ...props }: any) => (
              <div className={className}>
                <Initials {...props}>{getInitials(userName)}</Initials>
              </div>
            )}
          />
        )
      }
      key={userEmail}
      primaryText={userName}
      secondaryText={userEmail}
    />
  );
}

const Initials = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: ${fontFamily};
  font-size: 10px;
  line-height: 10px;
  color: ${colors.N500};

  width: 100%;
  height: 100%;
  background-color: ${colors.N40};
  border-radius: 50%;
`;
